/////////////////////////////////////////////////////////////////////////////////////////////////////////
//FileName: *management-units*.main.js
//FileType: Javascript Source file
//Size : ?
//Author : Harun Durmuş
//Created On : 11.12.2020 14:51
//Last Modified On : ?
//Copy Rights : Oceannet
//Description : Catalog>Management Units Component
////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { Fragment } from "react";
import { Switch, Route } from "react-router-dom";
import $ from "jquery";
import Detail from "./Detail";
import Edit from "./Edit";
import Table from "./Table";
import CreateManagementUnit from "./modals/createManagementUnit";
import RowDeleteModal from "../../modal/rowDelete";
import ColumnList from "../../../common/componet-jsons/column-list-catalog.json";
import * as CommonFunctions from "./functions/commonFunctions";

class ManagementUnits extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    var that = this;
    ColumnList.forEach(function (item) {
      if (item.name == "catalog>management-units") {
        window.$catalog_management_units_columnList = item["column-list"];
      }
    });

    /*** EKRANIN HERHANGİ BİRYERİNE TIKLANINCA POPUP KALDIRMAK İÇİN KULLANILAN FONKSİYON ***/
    $(document)
      .unbind("mouseup")
      .mouseup(function (e) {
        var popup = $("#myPopup");
        if (
          !$("div.popup").is(e.target) &&
          !popup.is(e.target) &&
          popup.has(e.target).length === 0
        ) {
          $("#myPopup").html("");
          var popup = document.getElementById("myPopup");
          $("#myPopup").removeClass("show");
        }
      });

    $(document).on("click", ".catalog-action", function () {
      var actionId = $(this).attr("id");
      let modalId = window.$catalog_management_units_actions.filter(
        (act) => act["id"] === actionId
      )[0]["modal"];
      $("#" + modalId).modal("show");
    });
  }

  render() {
    const match = `${this.props.match.url}/${String(
      this.props.location.pathname.split("/")[2]
    )}`;
    return (
      <div className="border p-3 br5 full-width" id="border-mid">
        <Fragment>
          <Switch>
            <Route
              exact
              path={match}
              render={(props) => <Table {...props} />}
            />
            <Route
              path={`${match}/edit/:rowId`}
              render={(props) => <Edit {...props} />}
            />
            <Route
              path={`${match}/detail/:rowId`}
              render={(props) => <Detail {...props} />}
            />
          </Switch>
        </Fragment>
        <CreateManagementUnit />
        <RowDeleteModal
          id="management-units-mappen_beheren_delete_modal"
          handleDelete={CommonFunctions.rowsHandleDelete}
        />
      </div>
    );
  }
}

export default ManagementUnits;
